module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-06Merit_Prize_J01.89f5e438.png";